import React, { useState, useEffect } from "react";
import "./diwaliHeader.scss";
//swiper imports
import "swiper/swiper-bundle.css";
import laxmilogo from "../../../images/general/laxmi_logo.png";
import hamburger from "../../../assets/hamburger.svg";
import cross from "../../../assets/black_cross.svg";
//hooks
import { NavLink } from "react-router-dom";

import {
  diwali2025,
  diwali2025About,
  diwali2025Gallery,
  diwali2025ParticipateForm,
  diwaliWinners2025,
} from "../../../helpers/constant-words";
import { buttonbackground2025 } from "../../../images";
const body = document.querySelector("body");

const Diwaliheader = (props) => {
  const [copyHashTag, setCopyHashTag] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    document.querySelector(".px-0.MainNavBar.shadow-lg").style.display = "none";
    document.querySelector(".CyanBg.MainFooter").style.display = "none";
    if (body) {
      body.style.height = "auto";
    }
  }, []);

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    if (copyHashTag) {
      let copiedTimeout = setTimeout(() => {
        setCopyHashTag(null);
      }, 3000);
      return () => {
        clearTimeout(copiedTimeout);
      };
    }
  }, [copyHashTag]);

  useEffect(() => {
    if (isMenuOpen) {
      // Disable scroll
      body.style.overflow = "hidden";
    } else {
      // Enable scroll
      body.style.overflow = "auto";
    }
  }, [isMenuOpen]);

  return (
    <>
      <main className="diwali_page_main2025">
        <header className="diwali_header2025">
          {/* If Going Live Hide This Start*/}
          <img
            src={isMenuOpen ? cross : hamburger}
            alt="Hamburger Icon"
            className={`hamburger_icon ${
              isMenuOpen ? "close_icon" : "open_icon"
            }`}
            onClick={() => handleMenuClick()}
          />
          {/* If Going Live Hide This End*/}
          <figure className="laxmilogo_wrapper">
            <NavLink to={diwali2025}>
              <img src={laxmilogo} alt="laxmi logo" className="laxmilogo" />
            </NavLink>
          </figure>
          {/* If Going Live Hide This Start*/}
          <div className={`nav_flex ${isMenuOpen ? "active" : ""}`}>
            <div className="logo_wrapper">
              <NavLink to={diwali2025}>
                <img src={laxmilogo} alt="laxmi logo" className="laxmilogo" />
              </NavLink>
            </div>
            <ul className="nav_links">
              <li className="confetti_animation">
                <NavLink to={diwaliWinners2025}>Winners</NavLink>
              </li>
              <li>
                <NavLink to={diwali2025About}>About</NavLink>
              </li>
              <li>
                <NavLink to={diwali2025Gallery}>Gallery</NavLink>
              </li>
              <li>
                <NavLink to={diwali2025ParticipateForm} className="white_cta">
                  Participate Now
                  <img
                    className="button_background"
                    src={buttonbackground2025}
                    alt="button background"
                    width={263}
                    height={56}
                  />
                </NavLink>
              </li>
            </ul>
          </div>
          {/* If Going Live Hide This End*/}
        </header>
      </main>
    </>
  );
};

export default Diwaliheader;
